import React, { useState, FormEvent } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import {PasswordInput, Button, Text, Card, Title, Flex} from '@mantine/core';
import {BackendUrl} from "../../util/config";

const ResetPassword: React.FC = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const navigate = useNavigate();

    const [newPassword, setNewPassword] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e: FormEvent) => {
        e.preventDefault();
        setError('');
        setMessage('');

        if (!token) {
            setError('No token found in URL.');
            return;
        }

        try {
            const response = await axios.post(BackendUrl + '/auth/reset-password', {
                token,
                newPassword
            });
            setMessage(response.data.message);
            // Wait for 3 seconds then navigate to /login
            setTimeout(() => {
                navigate('/login');
            }, 3000);

        } catch (err: any) {
            setError(err.response?.data?.error || 'Something went wrong');
        }
    };

    return (
        <Flex justify={"center"} align={"center"} h={"100vh"} >
            <Flex align={"flex-start"} direction={"column"}>
                <Title order={2} mb="md">
                    Passwort Zurücksetzen
                </Title>

                <Card w={400} p="md">
                    <form onSubmit={handleSubmit}>
                        {error && <Text color="red" mb="sm">{error}</Text>}
                        {message && <Text color="green" mb="sm">{message}</Text>}

                        <PasswordInput
                            label="Neues Passwort"
                            required
                            mb="sm"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.currentTarget.value)}
                        />
                        <Flex justify={"flex-end"}>
                            <Button type="submit">Setze neues Passwort</Button>
                        </Flex>
                    </form>
                </Card>

                <Flex  align={"center"} direction={"row"} mt={"15px"} gap={"5px"}>
                    <Text>An Passwort erinnert? Klicke</Text>
                    <Button p={"0px"} variant="transparent" onClick={() => navigate('/login')}>
                        hier
                    </Button>
                    <Text>um Anzumelden</Text>
                </Flex>
            </Flex>

        </Flex>

    );
};

export default ResetPassword;
